import { Divider } from '@byecode/ui'
import type { ViewOptions, ViewType } from '@lighthouse/core'
import { useAtomValue } from 'jotai'
import React, { useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { getBlockAndPageDesignLimit } from '@/components/StyleSetting'
import AnimationSetting from '@/components/StyleSetting/AnimationSetting'
import { PositionSetting } from '@/components/StyleSetting/PositionSetting'
import { SizeSetting } from '@/components/StyleSetting/SizeSetting'

import { dataSourceAtom } from '../atoms'
import { BlockConfigureSegmentedControl } from '../Common/BlockConfigureSegmentedControl'
import { CursorSetting } from '../Common/CursorSetting'
import type { BlockSettingsSegmentedEnum } from '../constants'
import { BLOCK_SETTINGS_SEGMENTED_ENUM } from '../constants'
import { EmptySetting } from '../CustomView/Basic/EmptySetting'
import { Data } from './Data'
import { Design } from './Design'
import type { ViewBaseSlice } from './formSlice'
import { Operate } from './Operate'
import { ViewTypeSwitcher } from './ViewTypeSwitcher'

interface ViewSettingProps {
    id: string
}

/** 视图block设置 */
const ViewSetting: React.FC<ViewSettingProps> = ({ id }) => {
    const styleProps = getBlockAndPageDesignLimit('view')
    const dataSource = useAtomValue(dataSourceAtom)
    const { watch } = useFormContext<ViewBaseSlice>()
    const viewType = (watch('viewType') ?? 'table') as ViewType

    const [currentTab, setCurrentTab] = useState<BlockSettingsSegmentedEnum>(BLOCK_SETTINGS_SEGMENTED_ENUM.DESIGN)

    return (
        <>
            <BlockConfigureSegmentedControl isInterAction value={currentTab} onChange={setCurrentTab} />

            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.DESIGN && (
                <>
                    <ViewTypeSwitcher />
                    <PositionSetting {...styleProps.position} />
                    <Divider />
                    <SizeSetting {...styleProps.size} />
                    <Divider />
                    <Design viewType={viewType} dataSource={dataSource} />
                    <Divider />
                    <EmptySetting />
                    <Divider />
                    <Controller name="cursor" render={({ field }) => <CursorSetting {...field} />} />
                </>
            )}

            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.CONFIGURE && (
                <Data viewType={viewType} currentTab={currentTab} dataSource={dataSource} />
            )}

            {/* 用户操作 */}
            {currentTab === BLOCK_SETTINGS_SEGMENTED_ENUM.INTERACTION && dataSource && (
                <>
                    <Operate id={id} viewType={viewType} dataSource={dataSource} />
                    <Divider />
                    <AnimationSetting />
                </>
            )}
        </>
    )
}

export default ViewSetting
